import { getCardImage } from "@/utils/getCardImage";
import { Box } from "styled-system/jsx";

export const CardImage = ({
  img = "headless_haunt",
  position = "top",
  minH = "300px",
}: {
  img?: string;
  position?: "top" | "bottom";
  minH?: string;
}) => {
  return (
    <Box
      w="inherit"
      h="inherit"
      position="relative"
      m="0.5rem auto"
      borderRadius="1rem"
      mb={position === "top" ? "unset" : "unset"}
      mt={position === "bottom" ? "-0.25rem" : "unset"}
      isolation="isolate"
      transform="unset"
      opacity="1"
      transition="all 0.25s ease"
    >
      <Box
        style={{
          backgroundImage: `url(${getCardImage(img ?? "")})`,
        }}
        w="100%"
        h="100%"
        minH={minH}
        backgroundPosition="top"
        backgroundSize="contain"
        backgroundRepeat="no-repeat"
        transition="all 0.25s ease"
        // bg="gray.400"
      />
    </Box>
  );
};
